import { Box, Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

/**
 * Without browser chrome there is no address bar spinner and no "you are offline" page,
 * so an installed app that loses connectivity just looks broken. This says so out loud.
 */
export const OfflineNotice = () => {
  const { formatMessage } = useIntl()
  const [isOffline, setIsOffline] = useState(
    () => typeof navigator !== 'undefined' && !navigator.onLine
  )

  useEffect(() => {
    const goOnline = () => setIsOffline(false)
    const goOffline = () => setIsOffline(true)
    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)
    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  if (!isOffline) {
    return null
  }

  return (
    <Box
      px={4}
      py={3}
      backgroundColor="ctaBlack.500"
      textAlign="center"
      aria-live="polite"
      data-testid="offline-notice"
    >
      <Text fontSize="sm" fontWeight="500" color="white">
        {formatMessage({
          id: 'pwa.offline.notice',
          defaultMessage: 'You are offline. Some things will not work until you reconnect.',
        })}
      </Text>
    </Box>
  )
}
